(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-blogs-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('all-blogs-search')) {
    customElements.define('all-blogs-search', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;

        this.input = this.querySelector('[data-blog-search-input]');
        this.dropdown = this.querySelector('[data-blog-search-dropdown]');
        this.results = this.querySelector('[data-blog-search-results]');
        this.message = this.querySelector('[data-blog-search-message]');
        this.viewAll = this.querySelector('[data-blog-search-all]');
        this.status = this.querySelector('[data-blog-search-status]');
        this.form = this.querySelector('form');
        this.cache = new Map();
        this.requestId = (this.requestId || 0) + 1;
        this.activeIndex = -1;
        this.composing = false;
        this.events = new AbortController();
        const options = { signal: this.events.signal };

        this.input.setAttribute('role', 'combobox');
        this.input.setAttribute('aria-autocomplete', 'list');
        this.input.setAttribute('aria-controls', this.results.id);
        this.input.setAttribute('aria-expanded', 'false');
        this.input.addEventListener('input', () => this.scheduleSearch(), options);
        this.input.addEventListener('focus', () => this.scheduleSearch(), options);
        this.input.addEventListener('compositionstart', () => {
          this.composing = true;
          this.close();
        }, options);
        this.input.addEventListener('compositionend', () => {
          this.composing = false;
          this.scheduleSearch();
        }, options);
        this.input.addEventListener('keydown', (event) => {
          if (event.isComposing || this.composing || event.keyCode === 229) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            return;
          }
          if (this.dropdown.hidden || !this.links?.length) return;
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            const index = event.key === 'ArrowDown' ? this.activeIndex + 1 : this.activeIndex < 0 ? this.links.length - 1 : this.activeIndex - 1;
            this.setActive(index);
          } else if (event.key === 'Enter' && this.activeIndex >= 0) {
            event.preventDefault();
            this.links[this.activeIndex].click();
          }
        }, options);
        this.results.addEventListener('pointerover', (event) => {
          const index = this.links?.indexOf(event.target.closest('[role="option"]')) ?? -1;
          if (index >= 0) this.setActive(index, false);
        }, options);
        this.form.addEventListener('submit', () => this.close(), options);
        const closeOutside = (event) => {
          if (!this.contains(event.target)) this.close();
        };
        document.addEventListener('pointerdown', closeOutside, options);
        document.addEventListener('focusin', closeOutside, options);
      }

      disconnectedCallback() {
        this.close();
        this.events?.abort();
        this.events = null;
      }

      get query() {
        return this.input.value.trim().replace(/\s+/g, ' ');
      }

      close() {
        window.clearTimeout(this.timer);
        this.request?.abort();
        this.requestId += 1;
        this.dropdown.hidden = true;
        this.results.removeAttribute('aria-busy');
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        this.activeIndex = -1;
        this.status.textContent = '';
      }

      scheduleSearch() {
        this.close();
        const query = this.query;
        if (this.composing || query.length < 2) return;
        const requestId = this.requestId;
        this.timer = window.setTimeout(() => this.search(query, requestId), 220);
      }

      setActive(index, scroll = true) {
        this.activeIndex = (index + this.links.length) % this.links.length;
        this.links.forEach((link, linkIndex) => link.setAttribute('aria-selected', String(linkIndex === this.activeIndex)));
        const activeLink = this.links[this.activeIndex];
        this.input.setAttribute('aria-activedescendant', activeLink.id);
        if (scroll) activeLink.scrollIntoView({ block: 'nearest' });
      }

      showMessage(text) {
        this.links = [];
        this.results.replaceChildren();
        this.message.textContent = text;
        this.message.hidden = false;
        this.dropdown.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        this.status.textContent = text;
      }

      renderArticles(articles) {
        this.results.replaceChildren();
        this.results.scrollTop = 0;
        this.links = [];
        for (const article of articles.slice(0, 5)) {
          if (typeof article?.url !== 'string' || !article.url || typeof article.title !== 'string') continue;
          let articleUrl;
          try {
            articleUrl = new URL(article.url, window.location.origin);
          } catch {
            continue;
          }
          if (articleUrl.origin !== window.location.origin) continue;

          const item = document.createElement('li');
          item.setAttribute('role', 'presentation');
          const link = document.createElement('a');
          link.id = `${this.input.id}-Option-${this.links.length}`;
          link.className = 'all-blogs-list__suggest-link';
          link.href = articleUrl.href;
          link.setAttribute('role', 'option');
          link.setAttribute('aria-selected', 'false');
          link.tabIndex = -1;

          const media = document.createElement('span');
          media.className = 'all-blogs-list__suggest-media';
          media.setAttribute('aria-hidden', 'true');
          media.textContent = Array.from(article.title || '')[0] || '';
          const imageSource = typeof article.image === 'string' ? article.image : article.image?.url || article.image?.src;
          if (imageSource) {
            try {
              const imageUrl = new URL(imageSource, window.location.origin);
              if (imageUrl.protocol === 'https:' || imageUrl.protocol === 'http:') {
                imageUrl.searchParams.set('width', '112');
                const image = document.createElement('img');
                image.src = imageUrl.href;
                image.alt = '';
                image.width = 56;
                image.height = 56;
                image.loading = 'lazy';
                media.replaceChildren(image);
              }
            } catch {
              // Keep the title initial when a thumbnail URL is unavailable.
            }
          }
          const body = document.createElement('span');
          body.className = 'all-blogs-list__suggest-body';
          const title = document.createElement('span');
          title.className = 'all-blogs-list__suggest-title';
          title.textContent = article.title;
          body.append(title);
          if (article.blog_title || article.author) {
            const meta = document.createElement('span');
            meta.className = 'all-blogs-list__suggest-meta';
            meta.textContent = article.blog_title || article.author;
            body.append(meta);
          }
          link.append(media, body);
          item.append(link);
          this.results.append(item);
          this.links.push(link);
        }
        if (!this.links.length) {
          this.showMessage(this.dataset.emptyText);
          return;
        }
        this.message.hidden = true;
        this.dropdown.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        this.status.textContent = `${this.links.length} ${this.links.length === 1 ? 'article' : 'articles'} found.`;
      }

      async search(query, requestId) {
        if (requestId !== this.requestId || query !== this.query) return;
        const searchUrl = new URL(this.form.action, window.location.origin);
        searchUrl.searchParams.set('q', query);
        searchUrl.searchParams.set('type', 'article');
        searchUrl.searchParams.set('options[prefix]', 'last');
        this.viewAll.href = searchUrl.href;
        if (this.cache.has(query)) {
          this.renderArticles(this.cache.get(query));
          return;
        }

        this.request = new AbortController();
        this.showMessage(this.dataset.loadingText);
        this.results.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(this.dataset.suggestUrl, window.location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'article');
          url.searchParams.set('resources[limit]', '5');
          url.searchParams.set('resources[limit_scope]', 'each');
          url.searchParams.set('resources[options][fields]', 'title,body');
          const response = await fetch(url.href, { headers: { Accept: 'application/json' }, signal: this.request.signal });
          if (!response.ok) throw new Error('Article suggestions failed');
          const data = await response.json();
          if (requestId !== this.requestId || query !== this.query) return;
          const articles = data?.resources?.results?.articles;
          if (!Array.isArray(articles)) throw new Error('Invalid article suggestions');
          if (this.cache.size >= 20) this.cache.delete(this.cache.keys().next().value);
          this.cache.set(query, articles);
          this.renderArticles(articles);
        } catch (error) {
          if (error.name !== 'AbortError' && requestId === this.requestId && query === this.query) {
            this.showMessage(this.dataset.errorText);
          }
        } finally {
          if (requestId === this.requestId) this.results.removeAttribute('aria-busy');
        }
      }
    });
  }

  if (!customElements.get('all-blogs-articles')) {
    customElements.define('all-blogs-articles', class extends HTMLElement {
      connectedCallback() {
        if (this.pagination) return;

        this.articles = Array.from(this.querySelectorAll('[data-blog-article]'));
        this.pageSize = Math.max(1, Number(this.dataset.pageSize) || 9);
        this.pageCount = Math.ceil(this.articles.length / this.pageSize);
        if (this.pageCount < 2) return;

        this.heading = this.querySelector('h2');
        this.status = this.querySelector('[data-blog-page-status]');
        this.pagination = document.createElement('nav');
        this.pagination.className = 'all-blogs-list__pagination';
        this.pagination.setAttribute('aria-label', this.dataset.paginationLabel);
        this.pagination.setAttribute('aria-controls', this.querySelector('[data-blog-article-grid]').id);
        this.previousButton = this.createButton('←', this.dataset.previousLabel, () => this.showPage(this.page - 1));
        this.pagination.append(this.previousButton);
        this.pageButtons = Array.from({ length: this.pageCount }, (_, index) => {
          const button = this.createButton(String(index + 1), this.pageLabel(index + 1), () => this.showPage(index + 1));
          this.pagination.append(button);
          return button;
        });
        this.nextButton = this.createButton('→', this.dataset.nextLabel, () => this.showPage(this.page + 1));
        this.pagination.append(this.nextButton);
        this.append(this.pagination);
        this.showPage(1, false);
      }

      createButton(text, label, onClick) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = text;
        button.setAttribute('aria-label', label);
        button.addEventListener('click', onClick);
        return button;
      }

      pageLabel(page) {
        return this.dataset.pageLabel.replace('[number]', String(page));
      }

      showPage(page, moveFocus = true) {
        this.page = Math.min(this.pageCount, Math.max(1, page));
        const start = (this.page - 1) * this.pageSize;
        this.articles.forEach((article, index) => {
          article.hidden = index < start || index >= start + this.pageSize;
        });
        this.pageButtons.forEach((button, index) => {
          if (index + 1 === this.page) button.setAttribute('aria-current', 'page');
          else button.removeAttribute('aria-current');
        });
        this.previousButton.disabled = this.page === 1;
        this.nextButton.disabled = this.page === this.pageCount;

        if (moveFocus) {
          this.status.textContent = `${this.pageLabel(this.page)} / ${this.pageCount}`;
          this.heading.focus({ preventScroll: true });
          this.heading.scrollIntoView({ block: 'start', behavior: 'auto' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-blog-template"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupTagRail = (rail) => {
      if (!rail || rail.dataset.dragScrollBound === 'true') return;

      rail.dataset.dragScrollBound = 'true';

      let activePointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let didDrag = false;
      let suppressClick = false;

      const endDrag = () => {
        if (activePointerId !== null && rail.hasPointerCapture(activePointerId)) {
          rail.releasePointerCapture(activePointerId);
        }

        activePointerId = null;
        rail.classList.remove('is-dragging');

        if (didDrag) {
          suppressClick = true;
          window.setTimeout(() => {
            suppressClick = false;
          }, 160);
        }

        didDrag = false;
      };

      rail.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (rail.scrollWidth <= rail.clientWidth) return;

        activePointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = rail.scrollLeft;
        didDrag = false;
      });

      rail.addEventListener('pointermove', (event) => {
        if (activePointerId !== event.pointerId) return;

        const deltaX = event.clientX - startX;

        if (!didDrag && Math.abs(deltaX) > 6) {
          didDrag = true;
          rail.classList.add('is-dragging');

          if (!rail.hasPointerCapture(activePointerId)) {
            rail.setPointerCapture(activePointerId);
          }
        }

        if (!didDrag) return;

        rail.scrollLeft = startScrollLeft - deltaX;
      });

      rail.addEventListener('pointerup', (event) => {
        if (activePointerId !== event.pointerId) return;
        endDrag();
      });

      rail.addEventListener('pointercancel', (event) => {
        if (activePointerId !== event.pointerId) return;
        endDrag();
      });

      rail.addEventListener('click', (event) => {
        if (!suppressClick) return;

        if (event.target.closest('a')) {
          suppressClick = false;
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, true);
    };

    const setupArticleSuggest = (form) => {
      if (!form || form.dataset.articleSuggestBound === 'true') return;

      const input = form.querySelector('[data-seo-blog-suggest-input]');
      const results = form.querySelector('[data-seo-blog-suggest-results]');

      if (!input || !results) return;

      form.dataset.articleSuggestBound = 'true';

      const minQueryLength = 2;
      const resultLimit = 10;
      const cache = new Map();
      let debounceTimer = null;
      let abortController = null;
      let activeIndex = -1;
      let requestId = 0;

      const root = window.Shopify?.routes?.root || '/';

      const buildFullSearchUrl = (query) => {
        const url = new URL(form.action, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'article');
        url.searchParams.set('options[prefix]', 'last');
        return url.toString();
      };

      const setExpanded = (expanded) => {
        input.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      };

      const getSuggestionLinks = () => Array.from(results.querySelectorAll('.seo-blog__suggest-link'));

      const clearActive = () => {
        getSuggestionLinks().forEach((link) => link.classList.remove('is-active'));
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
      };

      const setActive = (index) => {
        const links = getSuggestionLinks();

        if (links.length === 0) {
          clearActive();
          return;
        }

        activeIndex = (index + links.length) % links.length;

        links.forEach((link, linkIndex) => {
          const isActive = linkIndex === activeIndex;
          link.classList.toggle('is-active', isActive);

          if (isActive) {
            input.setAttribute('aria-activedescendant', link.id);
            link.scrollIntoView({ block: 'nearest' });
          }
        });
      };

      const hideResults = () => {
        results.hidden = true;
        results.replaceChildren();
        form.classList.remove('is-loading');
        setExpanded(false);
        clearActive();
      };

      const renderState = (message) => {
        results.replaceChildren();

        const state = document.createElement('p');
        state.className = 'seo-blog__suggest-state';
        state.textContent = message;
        results.append(state);

        results.hidden = false;
        setExpanded(true);
        clearActive();
      };

      const renderArticles = (articles, query) => {
        results.replaceChildren();
        clearActive();

        if (articles.length === 0) {
          renderState('No matching articles.');
          return;
        }

        const list = document.createElement('ul');
        list.className = 'seo-blog__suggest-list';
        list.setAttribute('role', 'presentation');

        articles.forEach((article, index) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          const title = document.createElement('span');

          link.id = `${input.id}-Option-${index}`;
          link.className = 'seo-blog__suggest-link';
          link.href = article.url || buildFullSearchUrl(query);
          link.setAttribute('role', 'option');
          link.dataset.instant = '';

          title.className = 'seo-blog__suggest-title';
          title.textContent = article.title || 'Untitled article';
          link.append(title);

          if (article.blog_title || article.author) {
            const meta = document.createElement('span');
            meta.className = 'seo-blog__suggest-meta';
            meta.textContent = article.blog_title || article.author;
            link.append(meta);
          }

          link.addEventListener('mouseenter', () => setActive(index));
          item.setAttribute('role', 'presentation');
          item.append(link);
          list.append(item);
        });

        const allResultsLink = document.createElement('a');
        allResultsLink.className = 'seo-blog__suggest-all';
        allResultsLink.href = buildFullSearchUrl(query);
        allResultsLink.textContent = `View all article results for "${query}"`;

        results.append(list, allResultsLink);
        results.hidden = false;
        setExpanded(true);
      };

      const fetchArticles = async (query) => {
        if (cache.has(query)) {
          renderArticles(cache.get(query), query);
          return;
        }

        abortController?.abort();
        abortController = new AbortController();

        const currentRequestId = ++requestId;
        const suggestUrl = new URL(`${root}search/suggest.json`, window.location.origin);
        suggestUrl.searchParams.set('q', query);
        suggestUrl.searchParams.set('resources[type]', 'article');
        suggestUrl.searchParams.set('resources[limit]', String(resultLimit));
        suggestUrl.searchParams.set('resources[limit_scope]', 'each');
        suggestUrl.searchParams.set('resources[options][fields]', 'title,body');

        form.classList.add('is-loading');
        renderState('Searching articles...');

        try {
          const response = await fetch(suggestUrl.toString(), {
            headers: { Accept: 'application/json' },
            signal: abortController.signal
          });

          if (!response.ok) throw new Error('Article suggest request failed');

          const data = await response.json();

          if (currentRequestId !== requestId || input.value.trim() !== query) return;

          const articles = data?.resources?.results?.articles || data?.resources?.articles || [];
          cache.set(query, articles);
          renderArticles(articles, query);
        } catch (error) {
          if (error.name === 'AbortError') return;
          renderState('Article suggestions are unavailable.');
        } finally {
          if (currentRequestId === requestId) {
            form.classList.remove('is-loading');
          }
        }
      };

      const scheduleSearch = () => {
        const query = input.value.trim();
        window.clearTimeout(debounceTimer);

        if (query.length < minQueryLength) {
          abortController?.abort();
          hideResults();
          return;
        }

        debounceTimer = window.setTimeout(() => fetchArticles(query), 220);
      };

      input.addEventListener('input', scheduleSearch);

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= minQueryLength && results.childElementCount > 0) {
          results.hidden = false;
          setExpanded(true);
        }
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          hideResults();
          return;
        }

        if (results.hidden) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setActive(activeIndex + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActive(activeIndex - 1);
        } else if (event.key === 'Enter' && activeIndex >= 0) {
          const activeLink = getSuggestionLinks()[activeIndex];

          if (activeLink) {
            event.preventDefault();
            activeLink.click();
          }
        }
      });

      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) {
          hideResults();
        }
      });
    };

    const setupProductCarousel = (carousel) => {
      if (!carousel || carousel.dataset.productCarouselBound === 'true') return;

      const track = carousel.querySelector('[data-seo-blog-product-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-seo-blog-product-slide]'));
      const previousButton = carousel.querySelector('[data-seo-blog-product-prev]');
      const nextButton = carousel.querySelector('[data-seo-blog-product-next]');
      const dots = Array.from(carousel.querySelectorAll('[data-seo-blog-product-dot]'));

      if (!track || slides.length === 0) return;

      carousel.dataset.productCarouselBound = 'true';

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplayEnabled = carousel.dataset.autoplay === 'true' && slides.length > 1;
      const autoplayInterval = Math.max(Number.parseInt(carousel.dataset.autoplayInterval, 10) || 5000, 3000);
      let activeIndex = 0;
      let autoplayTimer = null;
      let scrollFrame = null;
      let isPointerOver = false;
      let hasFocusWithin = false;

      const normalizeIndex = (index) => (index + slides.length) % slides.length;

      const updateState = (index) => {
        activeIndex = normalizeIndex(index);

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.toggleAttribute('inert', !isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
        });
      };

      const goTo = (index, behavior = 'smooth') => {
        const nextIndex = normalizeIndex(index);
        const nextSlide = slides[nextIndex];

        updateState(nextIndex);
        track.scrollTo({
          left: nextSlide.offsetLeft - track.offsetLeft,
          behavior: reducedMotion.matches ? 'auto' : behavior
        });
      };

      const stopAutoplay = () => {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      };

      const startAutoplay = () => {
        stopAutoplay();

        if (!autoplayEnabled || reducedMotion.matches || document.hidden || isPointerOver || hasFocusWithin) return;

        autoplayTimer = window.setInterval(() => {
          goTo(activeIndex + 1);
        }, autoplayInterval);
      };

      const restartAutoplay = () => {
        stopAutoplay();
        startAutoplay();
      };

      previousButton?.addEventListener('click', () => {
        goTo(activeIndex - 1);
        restartAutoplay();
      });

      nextButton?.addEventListener('click', () => {
        goTo(activeIndex + 1);
        restartAutoplay();
      });

      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => {
          goTo(dotIndex);
          restartAutoplay();
        });
      });

      track.addEventListener('keydown', (event) => {
        let nextIndex = null;

        if (event.key === 'ArrowLeft') nextIndex = activeIndex - 1;
        if (event.key === 'ArrowRight') nextIndex = activeIndex + 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = slides.length - 1;
        if (nextIndex === null) return;

        event.preventDefault();
        goTo(nextIndex);
        restartAutoplay();
      });

      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const closestIndex = slides.reduce((closest, slide, slideIndex) => {
            const currentDistance = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
            const closestDistance = Math.abs(slides[closest].offsetLeft - track.offsetLeft - track.scrollLeft);
            return currentDistance < closestDistance ? slideIndex : closest;
          }, activeIndex);

          if (closestIndex !== activeIndex) updateState(closestIndex);
        });
      }, { passive: true });

      carousel.addEventListener('pointerenter', () => {
        isPointerOver = true;
        stopAutoplay();
      });

      carousel.addEventListener('pointerleave', () => {
        isPointerOver = false;
        startAutoplay();
      });

      carousel.addEventListener('focusin', () => {
        hasFocusWithin = true;
        stopAutoplay();
      });

      carousel.addEventListener('focusout', (event) => {
        if (carousel.contains(event.relatedTarget)) return;
        hasFocusWithin = false;
        startAutoplay();
      });

      const handleVisibilityChange = () => {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      };

      const handleReducedMotionChange = () => {
        if (reducedMotion.matches) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      };

      const handleResize = () => goTo(activeIndex, 'auto');

      document.addEventListener('visibilitychange', handleVisibilityChange);
      reducedMotion.addEventListener('change', handleReducedMotionChange);
      window.addEventListener('resize', handleResize);

      carousel.seoBlogCarouselCleanup = () => {
        stopAutoplay();
        window.cancelAnimationFrame(scrollFrame);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        reducedMotion.removeEventListener('change', handleReducedMotionChange);
        window.removeEventListener('resize', handleResize);
      };

      updateState(0);
      startAutoplay();
    };

    const setupSeoBlog = (scope = document) => {
      scope.querySelectorAll('.seo-blog__tag-list').forEach(setupTagRail);
      scope.querySelectorAll('[data-seo-blog-suggest-form]').forEach(setupArticleSuggest);
      scope.querySelectorAll('[data-seo-blog-product-carousel]').forEach(setupProductCarousel);
    };

    setupSeoBlog();

    document.addEventListener('shopify:section:load', (event) => setupSeoBlog(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-seo-blog-product-carousel]').forEach((carousel) => {
        carousel.seoBlogCarouselCleanup?.();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
